"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./BulletPoint.css");

var _react = _interopRequireDefault(require("react"));

var _ContentItem = _interopRequireDefault(require("../../shared/components/cms/ContentItem"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(_ref) {
  var className = _ref.className,
      contentKey = _ref.contentKey,
      superScript = _ref.superScript;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _classnames.default)(className, "bullet-list-item")
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "bullet",
    alt: "",
    src: require("../assets/redesign2020/products/checkmark.svg")
  }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
    tag: "span",
    contentKey: contentKey,
    className: superScript || ""
  }));
};

exports.default = _default;